export default __webpack_public_path__ + "static/media/2009.e5c7f8be.png";